import { useState } from 'react';
import { Button } from '@lululemon/b2b-ecom-pattern-library';
import Search from 'components/search';
import { useCart } from 'context';
import { useFormat } from 'helpers/hooks/useFormat';
import { getAccountConfig, AccountConfig, PermissionTypes } from 'helpers/permissionChecker';
import { FEATURE_FLAG_LIST, useFeatureFlags } from 'hooks';
import SkuUploadModal from 'ui/sku-upload-modal';
import { useAccount } from 'frontastic';
import styles from './secondary-nav.module.scss';
import AccountButton from '../account-button';
import QuickViewBag from '../quick-view-bag';

export const SecondaryNav = () => {
  const { cart } = useCart();
  const { account, hasCoordinatorRole } = useAccount();
  const { isFeatureEnabled } = useFeatureFlags();
  const accountConfig = getAccountConfig(account) as AccountConfig;
  const isViewCart = accountConfig.hasPermission(PermissionTypes.CreateMyCarts);
  const showQuickOrder = isFeatureEnabled(FEATURE_FLAG_LIST.ORDER_ON_BEHALF_BU_SELECTION) && hasCoordinatorRole;
  const [open, setIsOpen] = useState(false);
  const { formatMessage } = useFormat({ name: 'common_quick_order_cta' });

  return (
    <div className={styles.siteSecondaryNav}>
      <ul className={styles.siteSecondaryList}>
        {showQuickOrder && (
          <li>
            <Button variant="filled" onClick={() => setIsOpen(true)}>
              {formatMessage({ id: 'quick.order', defaultMessage: 'Quick Order' })}
            </Button>
            {open && <SkuUploadModal visible={open} setIsOpen={setIsOpen} />}
          </li>
        )}
        <li>
          <Search />
        </li>
        <li>
          <AccountButton />
        </li>
        {isFeatureEnabled(FEATURE_FLAG_LIST.CART) && isViewCart && (
          <li>
            <QuickViewBag cartCount={cart?.totalQuantity ?? 0} cart={cart} />
          </li>
        )}
      </ul>
    </div>
  );
};
